import { CREATE_ACCOUNT } from '../action';
import createCompany from './createCompany';
import { takeEvery } from 'redux-saga/effects';

export default function*() {
    yield takeEvery(CREATE_ACCOUNT, createCompany);
}
